import React, { useState, useEffect } from 'react';

const webDevTestimonialsData = [
  {
    id: 1,
    quote:
      'Experts Communication delivered a flawless, scalable web platform that transformed our business operations. The high-speed performance, clean architecture, and responsive design increased our user conversions significantly.',
    author: 'Harrison Blake',
    designation: 'Managing Director, Horizon Luxe Global',
    avatar: '/assets/images/team_member_1.png'
  },
  {
    id: 2,
    quote:
      'From complex backend integrations to a lightning-fast React front-end, their web development team executed our vision with precision and speed. The custom dashboard and seamless checkout are unmatched.',
    author: 'Elena Rostova',
    designation: 'Creative Director, Vanguard Studios',
    avatar: '/assets/images/team_member_2.png'
  },
  {
    id: 3,
    quote:
      'Their web development services stand out in quality and reliability. They handled our database architecture, APIs, and cloud deployment smoothly without any downtime. Truly top-tier developers in Pakistan.',
    author: 'Tariq Mansoor',
    designation: 'Founder & CEO, Apex Cloud Tech',
    avatar: '/assets/images/team_member_3.png'
  },
  {
    id: 4,
    quote:
      'Working with Experts Communication on our custom web development was an exceptional experience. The website is intuitive, ultra-fast on mobile, and built to scale effortlessly.',
    author: 'Sophia Chen',
    designation: 'Head of Growth, Amore Retail Group',
    avatar: '/assets/images/hr-manager.jpg'
  }
];

function WebDevelopmentTestimonialsSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto slide smoothly every 4.5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % webDevTestimonialsData.length);
    }, 4500);

    return () => clearInterval(timer);
  }, []);

  const handleDiscussClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('webdev-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  const currentTestimonial = webDevTestimonialsData[currentIndex];

  return (
    <section className="ecom-testimonial-section">
      <div className="container bpo-testimonial-container">
        {/* Left Column: Headings, Sliding Card, and Button */}
        <div className="bpo-testimonial-left">
          <span className="bpo-testimonial-tag">
            What clients say about our web development!
          </span>

          <h2 className="bpo-testimonial-title">
            Developing High-Performance Websites That <span className="text-red">Inspire & Scale</span>
          </h2>

          <p className="bpo-testimonial-desc">
            Discover authentic feedback and success stories from enterprise leaders, startup founders, and global brands whose platforms were engineered by Experts Communication’s web development team.
          </p>

          {/* Testimonial Card */}
          <div className="bpo-testimonial-card-wrapper">
            <div className="bpo-testimonial-card" key={currentTestimonial.id}>
              {/* Star Rating */}
              <div className="bpo-stars-row">
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
              </div>

              {/* Review Quote Text */}
              <p className="bpo-quote-text">
                "{currentTestimonial.quote}"
              </p>

              {/* Client Info & Quotation Icon */}
              <div className="bpo-client-row">
                <div className="bpo-client-info">
                  <img 
                    src={currentTestimonial.avatar} 
                    alt={currentTestimonial.author} 
                    className="bpo-client-avatar"
                  />
                  <div className="bpo-client-details">
                    <h4 className="bpo-client-name">{currentTestimonial.author}</h4>
                    <span className="bpo-client-role">{currentTestimonial.designation}</span>
                  </div>
                </div>

                {/* Quotation Symbol */}
                <div className="bpo-quote-icon">
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="rgba(255, 255, 255, 0.4)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.75-2-2-2H4c-1.25 0-2 .75-2 2v6c0 1.25.75 2 2 2h4c0 4-2 6-5 8z" />
                    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.75-2-2-2h-4c-1.25 0-2 .75-2 2v6c0 1.25.75 2 2 2h4c0 4-2 6-5 8z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Action Button */}
          <button className="btn-bpo-explore" onClick={handleDiscussClick}>
            Let's Discuss Your Project
          </button>
        </div>

        {/* Right Column: 5-Star Reviews Showcase Graphic */}
        <div className="bpo-testimonial-right">
          <div className="bpo-reviews-img-wrapper">
            <img 
              src="/assets/images/bpo_reviews_neon.jpg" 
              alt="5-Star Web Development Reviews Customer Showcase" 
              className="bpo-reviews-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default WebDevelopmentTestimonialsSlider;
